import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logoLight from "../../../../assets/image/grap04.png";
import logoDark from "../../../../assets/image/grap05.png";
import { useAuth } from '../../../../component/auth/AuthContext';
import ThemeToggle from '../../../../component/theme/ThemeToggle';
import { useTheme } from '../../../../component/theme/ThemeContext';
import { useTranslation } from 'react-i18next';
import "./NaviBar.scss";

const Navibar = () => {
  // Authentication related state
  const { getUser, userIsAuthenticated, userLogout } = useAuth();
  const user = getUser();
  const userRoleArray = user?.data?.role || [];
  const userRole = userRoleArray[0];

  // Navigation related state
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const themeCtx = useTheme();
  const logo = themeCtx?.theme === 'dark' ? logoDark : logoLight;
  
  useEffect(() => {
    if (!userIsAuthenticated()) {
      userLogout();
      navigate('/login');
    }
  }, [userIsAuthenticated, userLogout, navigate]);

  const logout = () => {
    userLogout();
  }

  // Profile dropdown open/close
  let closeTimeout;
  const openProfileDropdown = () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
    }
    setProfileDropdownOpen(true);
  };

  const closeProfileDropdown = () => {
    setProfileDropdownOpen(false);
  };

  // 사용자별 고정 색상 생성 (컴포넌트 마운트 시 한 번만 생성)
  const userColor = useMemo(() => {
    if (!user?.data?.username) return '#2DACEC';
    
    // 사용자 이름을 기반으로 일관된 색상 생성
    let hash = 0;
    for (let i = 0; i < user.data.username.length; i++) {
      hash = user.data.username.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }
    
    return color;
  }, [user?.data?.username]);

  return (
    <>
      <div className="wapper-toppbar">
        {/* LOGO */}
        <div className="wapper">
          <img
            src={logo}
            alt="logo"
            className="wapper__img"
            onClick={() => navigate('/home')}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {/* Right cluster: theme toggle + profile dropdown */}
        <div className="wapper-right">
          <ThemeToggle />
          <div
            className={`wapper__username ${location.pathname === '/profile' || location.pathname === '/userlist' ? 'active no-underline' : ''}`}
            onMouseEnter={openProfileDropdown}
            onMouseLeave={closeProfileDropdown}
          >
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', borderBottom: 'none' }}>
            <div
              style={{
                backgroundColor: userColor,
                color: '#fff',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              {user?.data?.username ? user.data.username.charAt(0).toUpperCase() : 'U'}
            </div>
            <span style={{ textDecoration: 'none', borderBottom: 'none' }}>{`${user?.data?.username}`}</span>
          </div>
          <span className="navbar__arrow" style={{ textDecoration: 'none', borderBottom: 'none' }}></span>
          {profileDropdownOpen && (
            <div className={`profile__submenu ${profileDropdownOpen ? 'visible' : ''}`}>
              <div
                className={`profile__submenu-item ${location.pathname === '/profile' ? 'active' : ''}`}
                onClick={() => navigate('/profile')}
              >
                {t('nav.profile')}
              </div>
              {userRole === 'ADMIN' && (
                <div
                  className={`profile__submenu-item ${location.pathname === '/userlist' ? 'active' : ''}`}
                  onClick={() => navigate('/userlist')}
                >
                  {t('nav.users')}
                </div>
              )}
              {userRole === 'ADMIN' && (
                <div
                  className={`profile__submenu-item ${location.pathname === '/license' ? 'active' : ''}`}
                  onClick={() => navigate('/license')}
                >
                  {t('nav.license')}
                </div>
              )}
              <div className="profile__submenu-item" onClick={logout}>
                {t('nav.logout')}
              </div>
            </div>
          )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Navibar;